import { flash, SubmitButton } from "@xola/ui-kit";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { Seller } from "types";
import { api } from "../../../api/api";
import { useSeller } from "../../../hooks/useAccount";
import { useInvalidate } from "../../../hooks/useInvalidation";
import { ConfirmLeaveModal } from "../../Common/ConfirmLeaveModal";
import { RichEditor } from "../../Common/RichEditor";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ContentLayout } from "../../Layout/ContentLayout";

export const CustomEmailFooter = () => {
    const seller = useSeller();
    const invalidate = useInvalidate();
    const [value, setValue] = useState<string>(seller.emailFooter ?? "");

    const { mutateAsync: saveEmailFooter, isLoading } = useMutation(async (payload: { emailFooter: string }) => {
        return api.patch<Seller>(`/sellers/${seller.id}`, payload);
    });

    const handleSubmit = async () => {
        const { data } = await saveEmailFooter({ emailFooter: value });
        invalidate("sellers", seller.id);
        flash.success("Successfully updated Custom Email Footer");

        /**
         * After saving the footer data, we need to update the local `value` state to the response returned by the API.
         * As some of the tags would be converted to self-closing tags in API response and comparing both would always return `false`.
         *
         * Ex. <br> is converted to <br />
         * */
        setValue(data.emailFooter ?? "");
    };

    const handleCancel = () => {
        setValue(seller.emailFooter ?? "");
    };

    return (
        <ContentLayout isWide isDisabled={isLoading}>
            <ConfirmLeaveModal isFormTouched={(seller.emailFooter ?? "") !== value} />
            <h2 className="mt-5">Email Footer</h2>
            <ContentLayout.Section title="Custom">
                <div className="flex flex-col">
                    <span className="text-sm font-bold">Email Footer</span>
                    <RichEditor
                        initialContent={value}
                        showVariableButton={false}
                        onChange={(html) => setValue(html ?? "")}
                    />

                    <ContentLayout.Footer preferenceSidebar>
                        <SubmitButton type="submit" isLoading={isLoading} onClick={handleSubmit}>
                            Save
                        </SubmitButton>
                        <SecondaryButton onClick={handleCancel}>Cancel</SecondaryButton>
                    </ContentLayout.Footer>
                </div>
            </ContentLayout.Section>
        </ContentLayout>
    );
};
